import React, { useState } from 'react';
import CompanyLogo from '../../../../components/ui/CompanyLogo';

interface InterviewTextQuestionProps {
  companyName: string;
  companyLogo: string;
  location: string;
  onWatchVideo: () => void;
  question: string;
  placeholder?: string;
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: (answer: string) => void;
}

export default function InterviewTextQuestion({
  companyName,
  companyLogo,
  location,
  onWatchVideo,
  question,
  placeholder = "Type your answer here...",
  currentStep,
  totalSteps,
  onBack,
  onNext,
}: InterviewTextQuestionProps) {
  const [answer, setAnswer] = useState('');

  return (
    <div className="flex flex-col h-screen bg-white">
      {/* HEADER */}
      <div className="flex-shrink-0 bg-white px-5 pt-[14px]">
        <div className="flex items-start justify-between mb-2">
          <div className="flex items-start gap-2">
            <CompanyLogo 
              src={companyLogo}
              alt={companyName}
              className="w-[57px] h-[57px] rounded"
            />
            <div className="flex flex-col justify-center">
              <h1 className="text-[19px] font-bold text-[#28292d]">{companyName}</h1>
              <p className="text-[17px] font-normal text-[#28292d]">{location}</p>
            </div>
          </div>
          <button onClick={onWatchVideo} className="flex items-center gap-1 self-center">
            <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 1.5L10 6L2 10.5V1.5Z" fill="#0156FF" stroke="#0156FF" strokeLinejoin="round"/>
            </svg>
            <span className="text-[16px] font-normal text-[#0156FF]">Watch Video</span>
          </button>
        </div>
        <div className="h-px bg-[#b9babf] mx-4" />
      </div>

      {/* CONTENT */}
      <div className="flex-1 overflow-y-auto px-4 pt-6 pb-20">
        <p className="text-[14px] font-bold text-[#8E8E8F] mb-2">
          Question {currentStep} of {totalSteps}
        </p>
        <h2 className="text-[20px] font-bold text-[#28292d] mb-6 leading-tight">
          {question}
        </h2>
        
        <textarea
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          placeholder={placeholder}
          className="w-full h-[200px] p-4 text-[16px] text-[#28292d] border border-[#b9babf] rounded-[12px] focus:outline-none focus:border-[#0156FF] resize-none"
        />
      </div>

      {/* BOTTOM BUTTONS */}
      <div className="fixed bottom-0 left-0 right-0 px-5 py-4 flex items-center justify-between bg-white border-t border-[#eeeeee] z-50">
        <button
          onClick={onBack}
          className="bg-[#8E8E8F] text-white text-[16px] font-bold rounded-full w-[90px] h-[40px] active:scale-[0.98] transition-transform flex items-center justify-center"
        >
          Back
        </button>
        <button
          onClick={() => answer.trim() && onNext(answer)}
          className={`${answer.trim() ? 'bg-[#0156FF]' : 'bg-[#b9babf]'} text-white text-[16px] font-bold rounded-full w-[90px] h-[40px] active:scale-[0.98] transition-transform flex items-center justify-center`}
          disabled={!answer.trim()}
        >
          Next
        </button>
      </div>
    </div>
  );
}

